import { SvgIconProps } from "../types";

export const SvgIcon = ({ src, width, height, ...props }: SvgIconProps) => (
  <img
    src={`/img/svg/${src}`}
    alt={props["aria-label"] || src}
    loading="lazy"
    width={width}
    height={height}
    style={{ width, height }}
  />
);
